import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "body-container-bk" }
const _hoisted_2 = { class: "body-container-90" }
const _hoisted_3 = { id: "section0" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_5 = { id: "section1" }
const _hoisted_6 = { class: "body-container-gr" }
const _hoisted_7 = { class: "body-container-90" }
const _hoisted_8 = {
  id: "section2",
  class: "s-container"
}
const _hoisted_9 = { class: "body-container-bk" }
const _hoisted_10 = { class: "body-container-90" }
const _hoisted_11 = {
  id: "section3",
  class: "s-container"
}
const _hoisted_12 = { class: "body-container-gr" }
const _hoisted_13 = { class: "body-container-90" }
const _hoisted_14 = {
  id: "section4",
  class: "s-container"
}

import { onMounted } from 'vue'
import { useScrollToTop } from '@/composables/useUtils'
import HomeSection0Component from '@/components/HomeSection0Component.vue'
import HomeSection1Component from '@/components/HomeSection1Component.vue'
import HomeSection2Component from '@/components/HomeSection2Component.vue'
import HomeSection3Component from '@/components/HomeSection3Component.vue'
import HomeSection4Component from '@/components/HomeSection4Component.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

onMounted(() => {
  useScrollToTop()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("section", _hoisted_3, [
          _createVNode(HomeSection0Component)
        ]),
        _hoisted_4,
        _createElementVNode("section", _hoisted_5, [
          _createVNode(HomeSection1Component)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("section", _hoisted_8, [
          _createVNode(HomeSection2Component)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("section", _hoisted_11, [
          _createVNode(HomeSection3Component)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("section", _hoisted_14, [
          _createVNode(HomeSection4Component)
        ])
      ])
    ])
  ], 64))
}
}

})